import { PropsWithChildren, ReactNode } from 'react';
import { ICountry } from 'types/api';

// ! enums & types
export enum EApplicationSchemaTypes {
	HOME = 'home',
	HUB = 'hub',
	ACCOUNT = 'account',
	STORES_LIST = 'stores_list',
}

export enum EAppConfigurationPage {
	HOME = 'home',
	ALL_SERVICES = 'all-services',
	//
	HUB = 'hub',
	ACCOUNT = 'account',
	//
	VERTICALS = 'verticals',
	MOBILE_COMPONENTS = 'mobile-components',
	DEEP_LINKS = 'deep-links',
}

export enum EMyAccountGenericEntryComponentType {
	ABOUT_US = 'about_us',
	CARI_UNLIMITED = 'cari_unlimited',
	CARI_PRIZE = 'cari_prize',
	LANGUAGE = 'language',
	MANAGE_ADDRESSES = 'manage_addresses',
	SAVED_CARDS = 'saved_cards',
}

export enum ESchemaComponentPurpose {
	DEFAULT = 'default',
	PROMOTIONAL = 'promotional',
}

export enum ESchemaComponentType {
	// Home
	// BILLBOARD_BANNER = 'billboard_banner',
	GENERIC_VENDOR_SWIMLANE = 'generic_vendor_swimlane',
	HERO_VENDOR_SWIMLANE = 'hero_vendor_swimlane',
	MATRIX_VENDOR_SWIMLANE = 'matrix_vendor_swimlane',
	// TRACKABLE_ORDERS = 'trackable_orders',
	// VERTICALS_MOSAIC = 'verticals_mosaic',
	// BANNER = 'banner',
	// BANNER_CAROUSEL = 'banner_carousel',

	// Hub
	// VERTICALS_LIST = 'verticals_list',
	WIDE_VENDOR_SWIMLANE = 'wide_vendor_swimlane',

	// Account
	// PROFILE_SECTION = 'profile_section',
	// MY_ORDERS_SWIMLANE = 'my_orders_swimlane',
	// MY_FAVOURITES_SWIMLANE = 'my_favourites_swimlane',
	// MY_ACCOUNT_GENERIC_ENTRY = 'my_account_generic_entry',
}

// ! interfaces
export interface ISchemaComponentWithImage {
	id: number;
	image: string;
	image_ar: string;
}

export interface ISchemaComponentHeroSwimlane extends ISchemaComponent {
	type: ESchemaComponentType.HERO_VENDOR_SWIMLANE;
	title: string;
	background_color: string;
	vendors: ISchemaComponentWithImage[];
}

export interface ISchemaComponentGenericSwimlane extends ISchemaComponent {
	type: ESchemaComponentType.GENERIC_VENDOR_SWIMLANE;
	title: string;
	image: string;
	image_ar: string;
	vendors: ISchemaComponentWithImage[];
}

export interface ISchemaComponentMatrixVendorSwimlane extends ISchemaComponent {
	type: ESchemaComponentType.MATRIX_VENDOR_SWIMLANE;
	title: string;
	items_per_column: number;
	vendors: ISchemaComponentWithImage[];
}

export interface ISchemaComponentWideVendorSwimlane extends ISchemaComponent {
	type: ESchemaComponentType.WIDE_VENDOR_SWIMLANE;
	title: string;
	title_ar: string;
	vendors: ISchemaComponentWithImage[];
}

export type ISchemaComponentItem =
	| ISchemaComponentHeroSwimlane
	| ISchemaComponentGenericSwimlane
	| ISchemaComponentMatrixVendorSwimlane
	| ISchemaComponentWideVendorSwimlane;

export interface ISchemaComponent {
	id: number;
	type: ESchemaComponentType;
	purpose: ESchemaComponentPurpose;
	name: string;

	position: number;
}

export interface IAppSchema {
	id: number;
	country_id: ICountry['id'];
	name: string;
}

export interface IHomeConfigSchemaGet {
	schema: ISchemaComponentItem[];
}
export interface IAppComponentProps extends PropsWithChildren {
	id?: string;

	label?: ReactNode;

	type: ESchemaComponentType;
	content?: IHomeDnDContentElement;
}

export enum EContainerTypes {
	EMPTY = 'empty',
	ITEM_CONTAINER = 'item_container',
	REPLACE = 'replace',
}

export interface IHomeDnDContentElement {
	id: number;
	type?: ESchemaComponentType;
	component?: ISchemaComponentItem;
	position?: number;
	containerType?: EContainerTypes;
}
